import service from '@/api/request';

/**
 * 添加黑名单 请求参数
 *
 */
export interface PostBlackListAddRequest {
  /**
   * 赛事id
   */
  compId: number;
  /**
   * 通行证uid
   */
  uid: string;
}

/**
 * 添加黑名单 响应数据
 *
 */
export type PostBlackListAddResponse = any;

/**
 * 添加黑名单
 *
 */
export const postBlackListAdd = (params: PostBlackListAddRequest) =>
  service.post<PostBlackListAddRequest, PostBlackListAddResponse>('/api/blackList/add', params);

/**
 * 删除黑名单 请求参数
 *
 */
export interface PostBlackListDeleteRequest {
  /**
   * 赛事id
   */
  compId: number;
  /**
   * 通行证uid
   */
  uid: string;
}

/**
 * 删除黑名单 响应数据
 *
 */
export type PostBlackListDeleteResponse = any;

/**
 * 删除黑名单
 *
 */
export const postBlackListDelete = (params: PostBlackListDeleteRequest) =>
  service.post<PostBlackListDeleteRequest, PostBlackListDeleteResponse>('/api/blackList/delete', params);

/**
 * 分页查询黑名单 请求参数
 *
 */
export interface PostBlackListQueryForPageRequest {
  /**
   * 赛事id
   */
  compId: number;
  /**
   * 通行证uid
   */
  uid?: string;
  current?: number;
  size?: number;
}

/**
 * 分页查询黑名单 响应数据
 *
 */
export interface PostBlackListQueryForPageResponse {
  current?: number;
  pages?: number;
  records?: {
    /**
     * 赛事id
     */
    compId?: number;
    /**
     * 赛事名称
     */
    compName?: string;
    /**
     * 院系
     */
    department?: string;
    /**
     * 姓名
     */
    name?: string;
    /**
     * 通行证昵称
     */
    nick?: string;
    /**
     * 学校
     */
    orgName?: string;
    /**
     * 手机号
     */
    starPhone?: string;
    /**
     * 学号
     */
    stuNum?: string;
  }[];
  size?: number;
  total?: number;
}

/**
 * 分页查询黑名单
 *
 */
export const postBlackListQueryForPage = (params: PostBlackListQueryForPageRequest) =>
  service.post<PostBlackListQueryForPageRequest, PostBlackListQueryForPageResponse>(
    '/api/blackList/queryForPage',
    params
  );
